export default __webpack_public_path__ + "static/media/gpio.dbd8d72e.png";